/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelHubtranInvoiceExceptions.ts      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/hubtran-invoice-exceptions";

export class AutogenModelHubtranInvoiceExceptions<RowType extends ModelRow> extends Endpoint<RowType, RowHubtranInvoiceExceptionsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowHubtranInvoiceExceptions extends ModelRow<RowHubtranInvoiceExceptionsFields> {
	constructor(values?: Partial<RowHubtranInvoiceExceptionsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowHubtranInvoiceExceptionsFields {
	carrier: string;
	company_id: string;
	description: string;
	id: number;
	inv_approved_date: Date;
	invoice_date: Date;
	movement_id: string;
	order_id: string;
	severity: string;
}

